import React from 'react';
import WideContent from 'core/layout/content/wide-content';
import Translate from 'ui/atoms/translate';
import WithAuthenticatedPage from 'core/auth/components/with-authenticated-page';
import { AppType } from 'core/auth/types';
import Section from 'ui/atoms/section';
import useGoTo from 'hooks/use-go-to';
import { ISSUER_ROUTES } from 'apps/issuer/pages/routes.config';
import FriendReferralsTable from './friend-referrals-table';
import { useCurrentUserSelector } from 'src/core/auth/hooks';
import { hasDistributionViewFriendReferralPermission } from '../../helpers/distributionPlatformPermissions';

const FriendReferralsPage = () => {
  const goToFriendReferralsDetails = useGoTo(ISSUER_ROUTES.friendReferralDetails);
  const { currentUser } = useCurrentUserSelector();

  const hasPermission = hasDistributionViewFriendReferralPermission(currentUser?.associatedDistributionPlatforms || []);

  return (
    <WideContent title={<Translate name="issuerFriendReferrals.title" />}>
      <Section>
        <FriendReferralsTable
          goToDetails={(referralId: string) => goToFriendReferralsDetails({ referralId })}
          defaultLimit={50}
          hasPermission={hasPermission}
        />
      </Section>
    </WideContent>
  );
};

export default WithAuthenticatedPage(FriendReferralsPage, AppType.ISSUER);
